import Breadcrumbs from "atoms/Breadcrumbs";
import ContentContainer from "atoms/ContentContainer";
import FormSubmit from "atoms/FormSubmit";
import { useLocation, useNavigate } from "react-router-dom";
import { VStack, ScrollView } from "native-base";
import PersonalUserDetails from "molecules/PersonalUserDetails";
import TeamModal from "molecules/TeamModal";
import EmployeeForm from "molecules/EmployeeForm";
import CreateModal from "molecules/CreateModal";
import React, { useEffect, useState } from "react";
import AmplitudeHelper from "utils/analytics";
import { useFormik } from "formik";
import { validate } from "utils/validation";
import { useTranslation } from "react-i18next";
import useUpdateConnect from "./connect";

const SingleUpdate = () => {
  const location = useLocation();
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const [validateAfterSubmit, setValidateAfterSubmit] = useState(false);
  const {
    employeeId = 0,
    isEmployeeRequest = false,
    isRowDisabled = false,
    parentScreen = [],
  } = location.state || {};
  const {
    formData = {},
    banksList = [],
    getEmployeeId = () => {},
    getEmployeeRequestById = () => {},
    handleSubmit = () => {},
    handleCancel = () => {},
    handleSendData = () => {},
    errors = {},
    categoriesData = [],
    groupPayDates = {},
  } = useUpdateConnect({ isEmployeeRequest });

  const formik = useFormik({
    validationSchema: validate(t),
    initialValues: formData,
    enableReinitialize: true,
    validateOnChange: validateAfterSubmit,
    validateOnBlur: validateAfterSubmit,
    onSubmit: (values) => handleSubmit(values),
  });

  useEffect(() => {
    AmplitudeHelper.logEvent("single_employee_update_page");
    if (!employeeId || employeeId === 0) {
      navigate("/");
    }
    if (isEmployeeRequest) {
      getEmployeeRequestById(employeeId);
    } else {
      getEmployeeId(employeeId);
    }
  }, []);

  useEffect(() => {
    // Update Formik's values whenever formData changes
    formik.setValues({ ...formData, ...groupPayDates });
  }, [formData]);

  const { hasPendingUpdateRequest = false } = formData;

  return (
    <>
      <ContentContainer flex={[1, 1, 1, 0.85, 0.85]}>
        <Breadcrumbs
          currentPage="sideBar.changeEmployeeData"
          parentScreen={parentScreen}
        />
        <ScrollView pb="50px">
          <VStack space={5}>
            <PersonalUserDetails
              errors={errors}
              formikProps={formik}
              hasPendingUpdateRequest={hasPendingUpdateRequest}
            />
            <EmployeeForm
              errors={errors}
              banksList={banksList}
              formikProps={formik}
              isUpdate
              hasPendingUpdateRequest={hasPendingUpdateRequest}
              isRowDisabled={isRowDisabled}
              employeeId={employeeId}
              categoriesList={categoriesData}
              groupPayDates={groupPayDates}
            />
          </VStack>
        </ScrollView>
        <FormSubmit
          handleSubmit={() => {
            setValidateAfterSubmit(true);
            formik.handleSubmit();
          }}
          handleCancel={handleCancel}
          redirectBackTo="/"
        />
        <TeamModal />
      </ContentContainer>
      <CreateModal handleSendData={() => handleSendData(formik?.values)} />
    </>
  );
};

export default SingleUpdate;
